<template>
  <v-container fluid class="fill-height d-block">
    <Loading v-if="loading" />

    <template v-else>
      <v-row
        no-gutters
        class="flex-nowrap flex-column flex-md-row-reverse fill-height"
      >
        <div class="fill-width pa-2 mb-4 mb-md-0">
          <v-col
            v-for="(data, key, index) in versions"
            :key="index"
            class="text-left d-flex flex-column align-center"
          >
            <v-card-title
              v-if="key === 'Android'"
              class="py-1 d-inline-block full-width text-center"
              >{{ $t("panel.appVersioningPage.android") }}</v-card-title
            >
            <v-card-title
              v-else-if="key === 'IOS'"
              class="py-1 d-inline-block full-width text-center"
              >{{ $t("panel.appVersioningPage.ios") }}</v-card-title
            >
            <v-card
              color="gray2"
              elevation="0"
              class="pa-3 overflow-hidden device-info-block"
            >
              <div v-for="(field, key, index) in data" :key="`fields-${index}`">
                {{ key }}: {{ field }}
              </div>
            </v-card>
          </v-col>
        </div>
        <v-divider
          vertical
          class="py-10 d-none d-md-block ma-auto divider-app-versioning"
        />
        <div class="fill-width pa-2 pt-5 pt-md-15 fill-height">
          <v-form
            ref="form"
            @submit.prevent="addVersion"
            class="d-flex flex-column align-center fill-height"
          >
            <v-text-field
              v-model="versionModel.directDownloadLink"
              :rules="rules"
              required
              :label="$t('panel.appVersioningPage.directDownloadLink')"
              filled
              dense
              class="theme-custom-input flex-grow-0"
            >
            </v-text-field>

            <v-text-field
              v-model="versionModel.storeDownloadLink"
              :rules="rules"
              required
              :label="$t('panel.appVersioningPage.storeDownloadLink')"
              filled
              dense
              class="theme-custom-input flex-grow-0"
            >
            </v-text-field>

            <v-select
              :menu-props="{ bottom: true, offsetY: true }"
              class="theme-custom-input flex-grow-0"
              v-model="versionModel.osType"
              :rules="rules"
              required
              :items="osTypes"
              :label="$t('panel.appVersioningPage.osType')"
              dense
              filled
            />

            <v-text-field
              v-model="versionModel.version"
              :rules="rules"
              required
              :label="$t('panel.appVersioningPage.version')"
              filled
              dense
              class="theme-custom-input flex-grow-0"
            >
            </v-text-field>

            <v-textarea
              v-model="description"
              :rules="descriptionRules"
              :label="$t('panel.appVersioningPage.label')"
              filled
              dense
              class="theme-custom-input flex-grow-0"
            >
              <template v-slot:append>
                <v-btn
                  depressed
                  small
                  text
                  color="primary"
                  @click="addDescription"
                >
                  {{ $t("panel.appVersioningPage.add") }}
                </v-btn>
              </template>
            </v-textarea>

            <v-card
              v-if="versionModel.description.length"
              color="gray2"
              elevation="0"
              width="380"
              class="pa-3 flex-grow-0"
            >
              <div>
                {{ $t("panel.appVersioningPage.descriptions") }}
              </div>

              <v-row
                v-for="(desc, index) in versionModel.description"
                :key="index"
              >
                <v-col>
                  <span class="me-2">{{ index + 1 }}: {{ desc }}</span>
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    depressed
                    small
                    text
                    color="error"
                    @click="removeDescription(desc)"
                  >
                    {{ $t("panel.appVersioningPage.remove") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>

            <v-switch
              v-model="versionModel.forceVersion"
              :label="$t('panel.appVersioningPage.forceVersion')"
              class="flex-grow-0"
            ></v-switch>

            <v-btn
              depressed
              color="primary"
              :loading="submitLoading"
              type="submit"
              width="300px"
              class="py-6 mt-4 mt-md-auto flex-grow-0"
              max-width="100%"
            >
              {{ $t("panel.appVersioningPage.submit") }}
            </v-btn>
          </v-form>
        </div>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import { versioningService } from "@/services";
import Loading from "@/components/Common/Loading";

export default {
  name: "app-versioning",
  components: { Loading },
  data() {
    return {
      loading: false,
      submitLoading: false,
      versions: {},
      description: "",
      versionModel: {
        description: [],
        directDownloadLink: "",
        forceVersion: false,
        osType: "Android",
        storeDownloadLink: "",
        version: ""
      },
      osTypes: ["Android", "IOS"],
      rules: [v => !!v || this.$t("panel.appVersioningPage.notEmpty")],
      descriptionRules: [
        () =>
          this.versionModel.description.length ||
          this.$t("panel.appVersioningPage.description")
      ]
    };
  },
  mounted() {
    this.getVersions();
  },
  methods: {
    addDescription() {
      if (this.description)
        this.versionModel.description.push(this.description);
      this.description = "";
    },
    removeDescription(item) {
      this.versionModel.description = [
        ...this.versionModel.description.filter(elem => elem !== item)
      ];
    },
    getVersions() {
      this.loading = true;
      versioningService
        .getLastVersion()
        .then(response => {
          this.versions = response.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addVersion() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.submitLoading = true;
      versioningService
        .addVersion(this.versionModel)
        .then(res => {
          this.$toast.success(res.data.message);
          this.$refs.form.reset();
          this.getVersions();
        })
        .finally(() => {
          this.submitLoading = false;
        });
    }
  }
};
</script>

<style scoped lang="scss">
@import "AppVersioning";
</style>
